/**
 * React Query hooks for Knowledge Explorations
 */
import { useQuery } from '@tanstack/react-query';
import { explorationApi } from '@/lib/api/exploration.api';

export function useExplorations() {
  return useQuery({
    queryKey: ['explorations'],
    queryFn: () => explorationApi.list(),
  });
}

// Made with Bob
